export default __webpack_public_path__ + "static/media/imagen.a972dec0.svg";